export default class StorageKeyDefineLogin {
  static readonly LOGIN_TOKEN = 'login_token'
  static readonly LOGIN_USER_ID = 'login_user_id'
  static readonly LOGIN_USER_GROUP = 'login_user_group'
  static readonly LOGIN_FORM_CACHE = 'LOGIN_FORM_CACHE'
}
